import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import { useState } from "react";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { useClientUserRequestConsumptionPasswordReset } from "../hooks/useClientUserRequestConsumptionPasswordReset";

const RequestConsumptionPasswordReset = ({ id }: { id: string; }) => {
  const [isOpen, setIsOpen] = useState(false);

  const [messages, setMessages] = useState<string[] | boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const { mutate: requestPasswordReset, isPending: requestPasswordResetIsPending } = useClientUserRequestConsumptionPasswordReset({
    userId: id,
    onSuccess: () => {
      setIsOpen(false);
      setIsError(false);
      setMessages(['Senha enviada ao usuário por e-mail e/ou SMS.']);
    },
    onError: (error) => {
      setIsOpen(false);
      setIsError(true);
      setMessages((error.response?.data as { errors: { base: string[]; }; })?.errors?.base || null);
    },
  });

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={
          <Button name="request_consumption_password" disabled={requestPasswordResetIsPending}>
            Redefinir senha de consumo
          </Button>
        }
        useCancellableFooter
        showClose={false}
        title="Você deseja realmente alterar essa senha?"
        subtitle="Ao clicar em confirmar, a senha anterior do usuário será desativada."
        subtitleClassName="mt-1 text-md text-white-300"
        confirmButtonClassName="bg-blue-700"
        onConfirm={() => requestPasswordReset()}
      />

      {messages && (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError={isError}
        />
      )}
    </>
  );
};

export default RequestConsumptionPasswordReset;
